export const initDialogData = {
  ExpPOIId: null,
  ExpJobId: 0,
  IsCost: 0,
  JobId: null,
  CusId: null,
  ExpId: null,
  POIId: null,
  ContSize: "",
  ContTyp: "",
  ShpmTypId: null,
  TlrTypId: null,
  VatPrct: 0,
  WhtPrct: 0,
  UntPr: 0,
  Prty: 100,
  IsOwnRcpt:1,
  Rmk: ""
}

export const initFilterData = {
  CusId: null,
  JobId: null,
  ExpId: null,
}